import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createSlots as _createSlots, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/Crystal_Wedding_Logo_Submark_v2.svg'


const _hoisted_1 = { class: "sticky top-0 py-3 px-6 bg-white z-[49]" }
const _hoisted_2 = { class: "text-brand-600 text-3xl font-semibold" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center justify-end gap-4" }
const _hoisted_5 = { class: "z-40 bg-white shadow-sm border-t border-gray-200 border-b" }
const _hoisted_6 = {
  class: "sm:hidden md:block xl:hidden w-full h-full relative",
  id: "mobile-search-input"
}
const _hoisted_7 = { class: "absolute top-0 right-2 my-2" }
const _hoisted_8 = { class: "grid-cols-4 w-full justify-items-center h-full hidden sm:grid md:hidden xl:grid gap-px px-px" }
const _hoisted_9 = { class: "w-full h-full" }
const _hoisted_10 = { class: "w-full border-l border-gray" }
const _hoisted_11 = { class: "w-full border-l border-gray" }
const _hoisted_12 = { class: "w-full border-l border-gray" }
const _hoisted_13 = {
  key: 1,
  class: "w-full"
}
const _hoisted_14 = {
  key: 0,
  class: "flex justify-center mt-3"
}
const _hoisted_15 = { class: "flex justify-center" }
const _hoisted_16 = { class: "grid grid-cols-1 sm:grid-cols-[310px,310px] md:grid-cols-1 md:w-full lg:grid-cols-[310px,310px] lg:w-auto xl:grid-cols-[310px,310px,310px] 2xl:grid-cols-[310px,310px,310px,310px] 3xl:grid-cols-[310px,310px,310px,310px,310px] overflow-y-auto gap-4 p-4 sm:w-auto w-full" }
const _hoisted_17 = {
  key: 1,
  class: "flex justify-center my-3"
}
const _hoisted_18 = {
  key: 2,
  class: "max-w-150 mx-auto space-y-4 px-6 my-16"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-30 w-auto opacity-40 m-auto",
  src: _imports_0,
  alt: "Heartful Logo"
}, null, -1)
const _hoisted_20 = { class: "w-full bg-white px-px space-y-px shadow-xl" }
const _hoisted_21 = { class: "w-full border-t border-gray-200" }
const _hoisted_22 = { class: "w-full border-t border-gray-200" }
const _hoisted_23 = { class: "w-full border-t border-gray-200" }

import NowPlaying from './components/NowPlaying.vue'
	import SearchInput from './components/SearchInput.vue'
	import SongResult from './components/SongResult.vue'

	// Types
	import {
		Notification
	} from '@/types'

	// Auth
	import { 
		Auth
	} from '@/api/Auth'

	// Drag n drop
	import { 
		Container, 
		Draggable 
	} from 'vue3-smooth-dnd'

	import EventBus from '@/events' // events

	// Headless UI
	import {
		Dialog,
		DialogPanel,
		Menu,
		TransitionChild,
		TransitionRoot,
	} from '@headlessui/vue'

	// Icons
	import{
		UserIcon,
		MusicalNoteIcon,
		Square3Stack3DIcon
	} from '@heroicons/vue/20/solid'
	
	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// Queries
	import{
		getJobByRecordId,
		getSongByAlbumDetails
	}from './queries'

	// Store
	import { 
		store as _jobStore
	} from '@/store/job'
	import { 
		localesStore
	} from '@/store/locales'

	// Types
	import{
		Job,
		FindParameters,
		Song,
		Album,
		Scene
	} from '@/types'
    
	// Vue
	import {
		computed,
		inject,
		onBeforeUnmount,
		onMounted,
		ref
	} from 'vue'
	import {
		now,
		useDebounceFn
	} from "@vueuse/core"
	import ConfirmationCard from './components/ConfirmationCard.vue'

	
	const __default__ = { name: 'SearchMain' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: [
		'updateCount'
	],
  setup(__props, { emit: __emit }) {

	// Components
	const emit = __emit

	const {t} = useI18n()

	// Variables
	const job = ref<Job>({} as Job)
	const songSearchDetails = ref({
		artist: '',
		songName: '',
		albumName: '',
		genre: ''
	})
	const fetchS3File: any = inject('fetchS3File')

	const nowPlaying = ref<null | { expanded: boolean}>(null)
	
	const hasFilterApplied = computed(() => {
		if(songSearchDetails.value.artist.length || songSearchDetails.value.songName.length || songSearchDetails.value.albumName.length || songSearchDetails.value.genre.length) return true
		// if(albumList.value?.length) return true
		return false
	})

	const albumList = ref<Album[]>([])
	const songList = ref<Song[]>([])

	const jobStore = _jobStore()
	const _localesStore = localesStore()
	const jobDetails = ref({
		displayName: "",
		weddingDate: "",
		weddingTime: "",
		scenes: []
	})

	// On Mount
	onMounted(() => {
		job.value = jobStore.job

		// Get Job Details
		getJobDetails()

		EventBus.on('play-song', async (payload) => {
			playSong(payload)
		})

		EventBus.on('change-language', async () => {
			await getJobDetails()
			getSongs()
			updateScenes()
		})
	})

	onBeforeUnmount(() => {
		EventBus.off('play-song', null)
	})

	// Searching Functions
	async function getJobDetails() {
		const scriptParams = JSON.stringify({
			language: _localesStore.getFmLanguage
		})

		let params: FindParameters = {
			query: [
				{'_kp_jobs_id': job.value.jobID}
			],
			'script.prerequest': 'Set Language',
			'script.prerequest.param': scriptParams
		} 
		try{
			let result = await getJobByRecordId(params)

			// Check for valid session id
			if(result?.messages[0]?.code !== '0') {
				Auth.signOut()
			}

			jobDetails.value = {
				displayName: result?.response?.data[0]?.fieldData?.name_bride_groom_display,
				weddingDate: result?.response?.data[0]?.fieldData?.zctDateFormatted,
				weddingTime: result?.response?.data[0]?.fieldData?.time_start,
				scenes: (result?.response?.data[0]?.portalData?.portal_scenes) as []
			}
		}
		catch(e) {
			console.log(e)
		}

	}
	const numRecordsPerPage = ref<number>(50)
	const recordOffset = ref<number>(1)
	const numFoundSongs = ref<number>(0)
	const loading = ref(false)

	async function getSongs() {
		if(!hasFilterApplied.value) return
		loading.value = true
		if(songList.value) songList.value.length = 0

		const scriptParams = JSON.stringify({
			language: _localesStore.getFmLanguage
		})

		let params: FindParameters = {
			query: [
				{
					// English
					'song__ALBUM__albumID::name_search': songSearchDetails.value.albumName,
					'songs__albums__GENRES__genreID::genre_eng': songSearchDetails.value.genre,
					'songs__ARTISTS__allArtistID::artist_search': songSearchDetails.value.artist,
					'name_search': songSearchDetails.value.songName
				},
				{
					// Kanji
					'song__ALBUM__albumID::name': songSearchDetails.value.albumName,
					'songs__albums__GENRES__genreID::genre': songSearchDetails.value.genre,
					'songs__ARTISTS__allArtistID::artist': songSearchDetails.value.artist,
					'name_kanji': songSearchDetails.value.songName
				},
				{
					// Kana
					'song__ALBUM__albumID::name_kana': songSearchDetails.value.albumName,
					'songs__albums__GENRES__genreID::genre': songSearchDetails.value.genre,
					'songs__ARTISTS__allArtistID::artist': songSearchDetails.value.artist,
					'name_kana': songSearchDetails.value.songName
				},
				{
					// Multi
					'song__ALBUM__albumID::name_search': songSearchDetails.value.albumName.replace(/\s+/g, ""),
					'songs__albums__GENRES__genreID::genre_search': songSearchDetails.value.genre.replace(/\s+/g, ""),
					'songs__ARTISTS__allArtistID::artist_search': songSearchDetails.value.artist.replace(/\s+/g, ""),
					'name_search': songSearchDetails.value.songName.replace(/\s+/g, "")
				}
			],
			sort: [
				{	fieldName: '_kf_albums_id', sortOrder: 'ascend' }
			],
			limit: numRecordsPerPage.value,
			offset: recordOffset.value,
			'script.prerequest': 'Set Language',
			'script.prerequest.param': scriptParams
		} 

		try {
			let result = await getSongByAlbumDetails(params)

			// Check for valid session id
	
			if(result?.messages[0]?.code !== '0' && result?.messages[0]?.code !== '401') {
				Auth.signOut()
			}
			
			songList.value = await Promise.all(result?.response?.data?.map(async (item: any) => {
				const signedUrl = await fetchS3File(item.fieldData['song__album__ALBUMS_INFO__albumID::s3JSONPicture'])
				const song: Song = {
					songId: item.fieldData._kp_songs_id,
					albumName: item.fieldData['song__ALBUM__albumID::name_display'],
					additionalArtist: item.fieldData.zctAllAdditionalArtistDisplay,
					artworkFile: item.fieldData['song__album__ALBUMS_INFO__albumID::s3JSONPicture'],
					genre: item.fieldData['song__ALBUM__albumID::genre'],
					mainArtist: item.fieldData.zctArtistDisplay,
					signedUrl: signedUrl,
					songName: item.fieldData.name_display,
					songFile: item.fieldData['song__SONGS_INFO__songID::s3JSONSong']
				}

				return song
			}))

			numFoundSongs.value = result?.response?.dataInfo?.foundCount
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	}

	const searchOnStroke = useDebounceFn(async () => {
		currentPage.value = 1
		recordOffset.value = 1
		return await getSongs()
	}, 800)

	const nowPlayingSong = ref({
		artist: '',
		songName: '',
		albumName: '',
		genre: '',
		artworkUrl: '',
		signedUrl: ''
	})

	function playSong(nowPlaying: {
		artist: '',
		songName: '',
		albumName: '',
		genre: '',
		artworkUrl: '',
		signedUrl: ''
	}) {
		nowPlayingSong.value = nowPlaying
	}

	const songLoading = ref(false)
	function loadingSong(loading: boolean) {
		songLoading.value = loading
	}

	// #region Drag and Drop

	/**
	 * @function getSongIdByIndex
	 * @param songIndex - The dragged item's song index from the album
	 */
	function getSongIdByIndex(songIndex: any) {
		const songId = songList.value[songIndex]?.songId
		const song = songList.value[songIndex]
		return {songIndex, song}
	}

	/**
	 * @function shouldAnimateDrop -  Set dropping animation, called by the target container to which the dragged item will be droppped
	 */
	function shouldAnimateDrop() {
		return false
	}

	const draggingIndex = ref(null)
	function onDragStart({ isSource, payload }) {
		if(!isSource) return
		// payload holds the item being dragged, find the index and apply class
		draggingIndex.value = payload.songIndex
	}

	function onDragEnd() {
		// Remove the dragging class when drag ends
		draggingIndex.value = null
	}

	// #endregion

	// #region Filters

	const openSearchFilterModal = ref<{open: boolean}>({open: false})
	const openModal = ref<boolean>(false)
	const mobileFiltersTop = ref("")

	function toggleSearchFilterModal() {
		const mobileSearchInput = document.getElementById("mobile-search-input")
		const mobileSearchInputBottom = mobileSearchInput?.getBoundingClientRect().bottom
		mobileFiltersTop.value = `top: ${mobileSearchInputBottom}px;`
		openSearchFilterModal.value.open = !openSearchFilterModal.value.open
		openModal.value = !openModal.value
	}

	/**
	 * Clears the selected filter
	 * @function clearFilter
	 * @param key - The json key for the selected search filter
	 */
	function clearFilter(key: string) {
		songSearchDetails.value[key] = ''
	}

	// #endregion

	const confirmationModal = ref<{open: boolean}>({open: false})
	function toggleSaveSongModal() {
		confirmationModal.value.open = !confirmationModal.value.open
	}
	
	const showNotification = ref(false)
	const notificationIcon = ref(0)
	const notificationTitle = ref('')
	const notificationSubtitle = ref('')
	
	function displayNotification(notification: Notification) {
		notificationIcon.value = notification.icon
		notificationTitle.value = notification.title
		notificationSubtitle.value = notification.subtitle
		showNotification.value = true
	}

	const notes = computed(() => {
		if(_localesStore.locales.selected === 'ja') return jobStore.job.jobDetails.notesKanji
		else if(_localesStore.locales.selected === 'kana') return jobStore.job.jobDetails.notesKana
		return jobStore.job.jobDetails.notesEnglish
	})

	async function saveSongs(notification: Notification) {
		try {
			const jobId = jobStore.job?.jobID
			const scenesArray = jobStore.job?.jobDetails?.scenes
			const scenes = scenesArray?.map(scene => { 
				return { 
					sceneId: scene['job__JOBS_SCENES__jobID::_kp_jobs_scenes_id'], 
					songId: scene['job__JOBS_SCENES__jobID::zctSongID'],
					customSongName: scene.customSong?.songName ?? '',
					customSongArtist: scene.customSong?.mainArtist ?? '',
					customSongAlbum: scene.customSong?.albumName ?? '',
					customSongTrack: scene.customSong?.track ?? ''
				}
			})
			const res = await Auth.submitSongs(jobId, scenes, '', '', notes.value, false)
			const scriptResult = JSON.parse(res?.response?.scriptResult)

			if(scriptResult.errorCode != 0) {
				const error = scriptResult.errorMessage
				throw error
			}
			displayNotification(notification)
		}
		catch(e) {
			console.log(e)
			const notification: Notification = {
				title: t('songSelection.saveSongs'),
				subtitle: t('songSelection.saveError'),
				icon: 1
			}
			displayNotification(notification)
		}
		finally {
			toggleSaveSongModal()
		}
	}

	/**
	 * Update the scene songs to display in selected language
	 * @function updateScenes
	 */
	async function updateScenes() {
		const scenes = jobStore.job?.jobDetails?.scenes
		const jobDetailScenes = jobDetails.value.scenes
		let newScenes = jobDetailScenes.map((scene, i) => {
			const newSongId = scenes[i]['job__JOBS_SCENES__jobID::zctSongID']
			scene['job__JOBS_SCENES__jobID::zctSongID'] = newSongId
			return scene
		})

		jobStore.job.jobDetails.scenes = newScenes
	}

	// #region Pagination

	const numPages = computed(() => {
		return Math.ceil(numFoundSongs.value / numRecordsPerPage.value)
	})

	const currentPage = ref<number>(1)

	/**
	 * To load the specified page of records
	 * @function displayPageResults
	 * @param {string} pageNumber - The page of records to load
	 */
	async function displayPageResults(pageNumber: number) {
		currentPage.value = pageNumber
		recordOffset.value = (currentPage.value - 1) * numRecordsPerPage.value + 1
		loading.value = true 
		
		try {
			await getSongs()
		}
		catch(e) {
			console.log(e)
		}       
		finally {
			loading.value = false
		}
	}

	const currentSelectablePages = computed(() => {
		const selectablePages = []
		let startPage
		let endPage

		if(numPages.value <= 5) {
			startPage = 1
			endPage = numPages.value
		}
		else {
			if((currentPage.value - 1) == 1) {
				startPage = currentPage.value - 1
				endPage = currentPage.value + 3
			}
			else if((currentPage.value) == 1) {
				startPage = currentPage.value
				endPage = currentPage.value + 4
			}
			else if((currentPage.value + 1) == numPages.value) {
				startPage = currentPage.value - 3
				endPage = currentPage.value + 1
			}
			else if((currentPage.value) == numPages.value) {
				startPage = currentPage.value - 4
				endPage = currentPage.value
			}
			else{
				startPage = currentPage.value - 2
				endPage = currentPage.value + 2
			}
		}

		for(let i = startPage ?? 0 ; i <= (endPage ?? numPages.value) ; i++) {
			selectablePages.push(i)
		}
		return selectablePages
	})

	// #endregion


return (_ctx: any,_cache: any) => {
  const _component_tw_modal = _resolveComponent("tw-modal")!
  const _component_tw_notification = _resolveComponent("tw-notification")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_pagination_previous = _resolveComponent("v-pagination-previous")!
  const _component_v_pagination_page = _resolveComponent("v-pagination-page")!
  const _component_v_pagination_list = _resolveComponent("v-pagination-list")!
  const _component_v_pagination_next = _resolveComponent("v-pagination-next")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tw_modal, {
      title: _unref(t)('songSelection.saveSongs'),
      "modal-max-width": "max-w bottom-80 h-fit sm:bottom-0 sm:max-w-xs",
      ref_key: "confirmationModal",
      ref: confirmationModal
    }, {
      default: _withCtx(() => [
        _createVNode(ConfirmationCard, {
          onCloseSongsSave: toggleSaveSongModal,
          onSubmitSongSave: _cache[0] || (_cache[0] = (notification) => {saveSongs(notification)})
        })
      ]),
      _: 1
    }, 8, ["title"]),
    (showNotification.value)
      ? (_openBlock(), _createBlock(_component_tw_notification, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showNotification.value = false)),
          title: notificationTitle.value,
          subtitle: notificationSubtitle.value,
          duration: 2000,
          icon: notificationIcon.value
        }, null, 8, ["title", "subtitle", "icon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(jobDetails.value.displayName), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(jobDetails.value.weddingDate) + " - " + _toDisplayString(_ctx.$filters.hour24Time(jobDetails.value.weddingTime)), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_tw_button, {
            disabled: confirmationModal.value.open || _unref(jobStore).job.jobDetails.hasHadSongsSubmitted,
            onClick: toggleSaveSongModal,
            class: "btn-brand"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('songSelection.saveSongs')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = () => _unref(Auth).signOut()),
            href: "#",
            class: "link"
          }, _toDisplayString(_unref(t)('nav.signOut')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", {
        class: "flex flex-col h-full w-full",
        onSubmit: _withModifiers(getSongs, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SearchInput, {
            modelValue: songSearchDetails.value.artist,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((songSearchDetails.value.artist) = $event)),
              _unref(searchOnStroke)
            ],
            placeholder: _unref(t)('searchFilter.artist'),
            "aria-label": "Artist",
            class: "h-full w-full",
            dropdown: ""
          }, _createSlots({
            icon: _withCtx(() => [
              _createVNode(_unref(UserIcon))
            ]),
            _: 2
          }, [
            (songSearchDetails.value.artist.length)
              ? {
                  name: "trailing_inline",
                  fn: _withCtx(() => [
                    _createVNode(_component_XMarkIcon, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (clearFilter('artist')))
                    })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "placeholder", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_button, {
              onClick: toggleSearchFilterModal,
              plain: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ChevronDownIcon, {
                  class: _normalizeClass(["h-5 w-5 text-gray-400 transition-all duration-300", {'rotate-180': openModal.value}]),
                  "aria-hidden": "true"
                }, null, 8, ["class"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(SearchInput, {
              modelValue: songSearchDetails.value.artist,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((songSearchDetails.value.artist) = $event)),
                _unref(searchOnStroke)
              ],
              label: _unref(t)('searchFilter.artist'),
              placeholder: _unref(t)('searchFilter.artist'),
              "aria-label": "Artist",
              class: "h-full"
            }, _createSlots({
              icon: _withCtx(() => [
                _createVNode(_unref(UserIcon))
              ]),
              _: 2
            }, [
              (songSearchDetails.value.artist.length)
                ? {
                    name: "trailing_inline",
                    fn: _withCtx(() => [
                      _createVNode(_component_XMarkIcon, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (clearFilter('artist')))
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue", "label", "placeholder", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(SearchInput, {
              modelValue: songSearchDetails.value.songName,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => ((songSearchDetails.value.songName) = $event)),
                _unref(searchOnStroke)
              ],
              label: _unref(t)('searchFilter.song'),
              placeholder: _unref(t)('searchFilter.song'),
              "aria-label": "Song Name",
              class: "h-full"
            }, _createSlots({
              icon: _withCtx(() => [
                _createVNode(_unref(MusicalNoteIcon))
              ]),
              _: 2
            }, [
              (songSearchDetails.value.songName.length)
                ? {
                    name: "trailing_inline",
                    fn: _withCtx(() => [
                      _createVNode(_component_XMarkIcon, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (clearFilter('songName')))
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue", "label", "placeholder", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(SearchInput, {
              modelValue: songSearchDetails.value.albumName,
              "onUpdate:modelValue": [
                _cache[10] || (_cache[10] = ($event: any) => ((songSearchDetails.value.albumName) = $event)),
                _unref(searchOnStroke)
              ],
              label: _unref(t)('searchFilter.album'),
              placeholder: _unref(t)('searchFilter.album'),
              "aria-label": "Album Name",
              class: "h-full"
            }, _createSlots({
              icon: _withCtx(() => [
                _createVNode(_unref(Square3Stack3DIcon))
              ]),
              _: 2
            }, [
              (songSearchDetails.value.albumName.length)
                ? {
                    name: "trailing_inline",
                    fn: _withCtx(() => [
                      _createVNode(_component_XMarkIcon, {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (clearFilter('albumName')))
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue", "label", "placeholder", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(SearchInput, {
              modelValue: songSearchDetails.value.genre,
              "onUpdate:modelValue": [
                _cache[12] || (_cache[12] = ($event: any) => ((songSearchDetails.value.genre) = $event)),
                _unref(searchOnStroke)
              ],
              label: _unref(t)('searchFilter.genre'),
              placeholder: _unref(t)('searchFilter.genre'),
              "aria-label": "Genre",
              class: "h-full"
            }, _createSlots({
              icon: _withCtx(() => [
                _createVNode(_unref(Square3Stack3DIcon))
              ]),
              _: 2
            }, [
              (songSearchDetails.value.genre.length)
                ? {
                    name: "trailing_inline",
                    fn: _withCtx(() => [
                      _createVNode(_component_XMarkIcon, {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (clearFilter('genre')))
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue", "label", "placeholder", "onUpdate:modelValue"])
          ])
        ])
      ], 32)
    ]),
    (hasFilterApplied.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (numFoundSongs.value > numRecordsPerPage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_v_pagination, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_pagination_previous, {
                      href: "#",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (displayPageResults(currentPage.value - 1)))
                    }),
                    _createVNode(_component_v_pagination_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSelectablePages.value, (pageNum) => {
                          return (_openBlock(), _createBlock(_component_v_pagination_page, {
                            key: pageNum,
                            current: pageNum == currentPage.value,
                            href: `?page=${pageNum}`,
                            onClick: ($event: any) => (displayPageResults(pageNum))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(pageNum), 1)
                            ]),
                            _: 2
                          }, 1032, ["current", "href", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_pagination_next, {
                      href: "#",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (displayPageResults(currentPage.value + 1)))
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(17, (i) => {
                return _withDirectives(_createVNode(SongResult, {
                  key: i,
                  loading: loading.value
                }, null, 8, ["loading"]), [
                  [_vShow, loading.value]
                ])
              }), 64)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(songList.value, (song, songIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: songIndex }, [
                  _createVNode(_unref(Container), {
                    class: "hidden sm:block",
                    tag: "span",
                    "group-name": "results",
                    behaviour: "copy",
                    "get-child-payload": () => getSongIdByIndex(songIndex),
                    "should-animate-drop": shouldAnimateDrop,
                    onDragStart: onDragStart,
                    onDragEnd: onDragEnd
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Draggable), { class: "sm:max-w-[310px] md:max-w-full lg:max-w-[310px]" }, {
                        default: _withCtx(() => [
                          _createVNode(SongResult, {
                            class: _normalizeClass(['draggable-item', { 'opacity-50': draggingIndex.value === songIndex }]),
                            result: song,
                            onLoading: loadingSong,
                            onPlay: playSong
                          }, null, 8, ["class", "result"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["get-child-payload"]),
                  _createVNode(SongResult, {
                    class: "overflow-hidden block sm:hidden sm:max-w-[310px]",
                    result: song,
                    onLoading: loadingSong,
                    onPlay: playSong
                  }, null, 8, ["result"])
                ], 64))
              }), 128))
            ])
          ]),
          (numFoundSongs.value > numRecordsPerPage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_v_pagination, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_pagination_previous, {
                      href: "#",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (displayPageResults(currentPage.value - 1)))
                    }),
                    _createVNode(_component_v_pagination_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSelectablePages.value, (pageNum) => {
                          return (_openBlock(), _createBlock(_component_v_pagination_page, {
                            key: pageNum,
                            current: pageNum == currentPage.value,
                            href: `?page=${pageNum}`,
                            onClick: ($event: any) => (displayPageResults(pageNum))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(pageNum), 1)
                            ]),
                            _: 2
                          }, 1032, ["current", "href", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_pagination_next, {
                      href: "#",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (displayPageResults(currentPage.value + 1)))
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_v_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('placeholders.noFilters')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('placeholders.noFilters2')), 1)
            ]),
            _: 1
          }),
          (_unref(_localesStore).locales.selected == 'en')
            ? (_openBlock(), _createBlock(_component_v_text, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('sidebar.cutoffDateMessageStart')) + " " + _toDisplayString(_unref(jobStore).job.numDaysUpdateSong) + " " + _toDisplayString(_unref(t)('sidebar.cutoffDateMessageEnd')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", {
      class: _normalizeClass(["fixed bottom-0 flex w-full right-0 z-50", {'!z-[99]': nowPlaying.value?.expanded}])
    }, [
      _createVNode(NowPlaying, {
        loading: songLoading.value,
        "now-playing": nowPlayingSong.value,
        ref_key: "nowPlaying",
        ref: nowPlaying
      }, null, 8, ["loading", "now-playing"])
    ], 2),
    _createElementVNode("div", null, [
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: openModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-50 sm:hidden md:block xl:hidden",
            onClose: _cache[23] || (_cache[23] = ($event: any) => (openModal.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "fixed max-h-fit inset-0 md:ml-[409px] md:pr-[409px] flex w-full shadow-lg",
                style: _normalizeStyle(mobileFiltersTop.value)
              }, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "duration-300",
                  "enter-from": "transform scale-95 opacity-0 max-h-0",
                  "enter-to": "transform scale-100 opacity-100 max-h-96",
                  leave: "transition ease duration-300 transform",
                  "leave-from": "transform scale-100 opacity-100 max-h-96 h-96",
                  "leave-to": "transform scale-95 opacity-0 max-h-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative top-0 flex w-full flex-1 dark:bg-gray-900" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(SearchInput, {
                              modelValue: songSearchDetails.value.songName,
                              "onUpdate:modelValue": [
                                _cache[18] || (_cache[18] = ($event: any) => ((songSearchDetails.value.songName) = $event)),
                                _unref(searchOnStroke)
                              ],
                              placeholder: _unref(t)('searchFilter.song'),
                              "aria-label": "Song Name"
                            }, _createSlots({
                              icon: _withCtx(() => [
                                _createVNode(_unref(MusicalNoteIcon))
                              ]),
                              _: 2
                            }, [
                              (songSearchDetails.value.songName.length)
                                ? {
                                    name: "trailing_inline",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_XMarkIcon, {
                                        onClick: _cache[17] || (_cache[17] = ($event: any) => (clearFilter('songName')))
                                      })
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["modelValue", "placeholder", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(SearchInput, {
                              modelValue: songSearchDetails.value.albumName,
                              "onUpdate:modelValue": [
                                _cache[20] || (_cache[20] = ($event: any) => ((songSearchDetails.value.albumName) = $event)),
                                _unref(searchOnStroke)
                              ],
                              placeholder: _unref(t)('searchFilter.album'),
                              "aria-label": "Album Name"
                            }, _createSlots({
                              icon: _withCtx(() => [
                                _createVNode(_unref(Square3Stack3DIcon))
                              ]),
                              _: 2
                            }, [
                              (songSearchDetails.value.albumName.length)
                                ? {
                                    name: "trailing_inline",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_XMarkIcon, {
                                        onClick: _cache[19] || (_cache[19] = ($event: any) => (clearFilter('albumName')))
                                      })
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["modelValue", "placeholder", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(SearchInput, {
                              modelValue: songSearchDetails.value.genre,
                              "onUpdate:modelValue": [
                                _cache[22] || (_cache[22] = ($event: any) => ((songSearchDetails.value.genre) = $event)),
                                _unref(searchOnStroke)
                              ],
                              placeholder: _unref(t)('searchFilter.genre'),
                              "aria-label": "Genre"
                            }, _createSlots({
                              icon: _withCtx(() => [
                                _createVNode(_unref(Square3Stack3DIcon))
                              ]),
                              _: 2
                            }, [
                              (songSearchDetails.value.genre.length)
                                ? {
                                    name: "trailing_inline",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_XMarkIcon, {
                                        onClick: _cache[21] || (_cache[21] = ($event: any) => (clearFilter('genre')))
                                      })
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["modelValue", "placeholder", "onUpdate:modelValue"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 4)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})